import React from "react";
import PhoneInput from "./PhoneInput";

export const CONTACTO_VACIO = { contacto_nombre: "", contacto_parentesco: "", contacto_telefono: "" };

export default function ContactoAdicional({ value, onChange }) {
  const cambiar = (campo, valor) => onChange({ ...value, [campo]: valor });
  return (
    <fieldset className="space-y-3" data-testid="contacto-adicional">
      <legend className="font-display font-bold mb-2">Contacto adicional</legend>
      <label className="block text-sm">Nombre
        <input className="w-full rounded-lg border border-slate-300 px-3 py-2" maxLength={200}
          value={value.contacto_nombre || ""} onChange={(e) => cambiar("contacto_nombre", e.target.value)} data-testid="contacto-nombre" />
      </label>
      <label className="block text-sm">Parentesco
        <input className="w-full rounded-lg border border-slate-300 px-3 py-2" maxLength={60}
          placeholder="Ej. mamá, papá, tutor" value={value.contacto_parentesco || ""}
          onChange={(e) => cambiar("contacto_parentesco", e.target.value)} data-testid="contacto-parentesco" />
      </label>
      <label className="block text-sm">Teléfono
        <PhoneInput className="w-full rounded-lg border border-slate-300 px-3 py-2"
          value={value.contacto_telefono || ""} onChange={(v) => cambiar("contacto_telefono", v)} testId="contacto-telefono" />
      </label>
    </fieldset>
  );
}
